import React from 'react';
import PropTypes from 'prop-types';
import css from './ScaleField.css';

const RATES = [1, 2, 3, 4, 5];

const ScaleField = (props) => {
  const radioName = `${props.type}-${props.id}`;
  return (
    <div className={css['container']} role="radiogroup" aria-label={props.questionText}>
      {RATES.map(rate => (
        <div key={rate} className={css['option']}>
          <input 
            type="radio"
            name={radioName}
            id={`${radioName}-${rate}`}
            value={rate}
            checked={props.value === rate}
            onChange={e => props.setValue(parseInt(e.target.value))}
            disabled={props.isReadOnly}
          />
          <label htmlFor={`${radioName}-${rate}`}>{rate}</label>
        </div>
      ))}
    </div>
  );
}

ScaleField.propTypes = {
  value: PropTypes.number,
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  questionText: PropTypes.string.isRequired
}

export default ScaleField;
